
import React from "react";
import Infographics from '../Components/Dashboard/Resource-Center/Infographics';
import SessionTimeoutRedirect from '../Components/Common/SessionTimeoutRedirect'
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
const AuthInfographics = () => {
   const useAuth=()=>{
    const user=localStorage.getItem('user_id')
    const token = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, '$1');

    if(token){
      return true
    } else {
      localStorage.clear()
      return false
    }
  }
  const auth = useAuth();
  return auth ? <Infographics /> : <SessionTimeoutRedirect />
}
export default AuthInfographics;


